<template>
  <div class="card">
    <div class="card-header flex-header">
      <div>
        <h4 class="card-title">Login Information</h4>
      </div>
      <button @click="showing_details=!showing_details" class="btn btn-outline-primary"> 
        <span v-html="showing_details ? 'Hide' : 'Show'"></span> Info
      </button>
    </div>
    <div v-if="showing_details" class="card-body">
      <ul class="list-group list-group-bordered">
        <li v-if="invite_data.accept_user_invitation_url && !invite_data.invitation_accepted_at" 
          class="list-group-item">
          Invite link: {{ invite_data.accept_user_invitation_url }}
        </li>

        <li class="list-group-item d-flex justify-content-between align-items-center">
          Send invite (allows {{ user_type }} to set password)
          <button @click="send" class="badge badge-primary badge-pill">
            <template v-if="invite_data.invitation_sent_at">
              Resend Invite
            </template>
            <template v-else>
              Send Invite
            </template>

            <i v-if="sending" class="fa fa-spinner-third fa-spin ml-2"></i>
            <i v-else class="fa fa-paper-plane ml-1"></i>
          </button>
        </li>
        <li v-if="invite_data.invitation_sent_at"
          class="list-group-item d-flex justify-content-between align-items-center">
          Invite sent:
          <span class="badge badge-primary badge-pill">{{ invite_data.invitation_sent_at | moment("from", "now") }}</span>
        </li>
        <li class="list-group-item d-flex justify-content-between align-items-center">
          Invite accepted:
          <template v-if="invite_data.invitation_accepted_at">
            <span class="badge badge-success badge-pill">{{ invite_data.invitation_accepted_at | moment("from", "now") }}</span>  
          </template>
          <template v-else>
            <span class="badge badge-warning badge-pill">Not accepted yet</span>  
          </template>
        </li>
      </ul>

      <div class="form-group">
        <label>Message (optional)</label>
        <textarea v-model="custom_message" class="form-control" rows="5"></textarea>
        <p class="mb-0 mt-1"><b>Note: </b> This message will replace the standard email</p>
      </div>
    </div>
  </div>
</template>
<script>
import { HTTP } from "../api/resources";

export default {

  props: ["user_id", "user_type"],

  data() {
    return {
      sending: "",
      showing_details: false,
      invite_data: {},
      custom_message: ""
    }
  },

  created() {
    HTTP.get(`/invites/${this.user_id}`).then(response => {
        this.invite_data = response.data;
        this.sending = false;
      }).catch(e => {
        this.sending = false;
      })
  },

  methods: {
    send() {
      const self = this;
      this.sending = true;

      const data = {
          id: this.user_id,
          custom_message: this.custom_message
        }

      HTTP.post("/invites", data).then(response => {
          this.sending = false;
          this.invite_data = response.data;
          Alert.show("notice", `Invite sent to ${this.invite_data.email}!`);
        }).catch(e => {
          this.sending = false;
          Alert.show("error", "Invite not sent! Ensure email is set then try again or refresh.");
        })
    }
  }
}
</script>
